import { LeadsManagementTable, ArchivedLeadsTable } from '../components';
import { archivedLeadsConstants } from '../lib';

const ArchivedLeadsPage = ({ type }) => {
  return (type === archivedLeadsConstants.ARCHIVED_USER_TYPE ? <ArchivedLeadsTable /> : <LeadsManagementTable />);
};

export default ArchivedLeadsPage;
